var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"v-btn--bottom v-btn--fixed v-btn--right",staticStyle:{"z-index":"1"},attrs:{"title":_vm.$t('Create new article'),"color":"primary","to":"private/articles/create"}},[_vm._v("\n  "+_vm._s(_vm.$t("Create new article"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }